export const ALERT_TYPE_MAP = {
  success: ['check-circle', 'Success'],
  info: ['info-circle', 'Info'],
  warning: ['exclamation-triangle', 'Warning'],
  danger: ['exclamation-circle', 'Error']
};
